import { string, func } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

const AskHRExpertIcon = ({ fill, height, onClick, viewBox, width, ...rest }) => {
    return (
        <SvgIcon
            data-testid="askAnExpert-icon"
            width={width}
            height={height}
            onClick={onClick}
            viewBox={viewBox}
            fill="none"
            {...rest}
        >
            <path
                d="M80-160v-94q0-34 17-62.5t51-43.5q72-32 132-46t120-14q29 0 61.5 3.5T528-404l-49 49q-20-2-39.5-3.5T400-360q-58 0-105.5 10.5T172-306q-17 8-24.5 23t-7.5 29v34h319l60 60H80Zm545 16L484-285l42-42 99 99 213-213 42 42-255 255ZM292-524q-42-42-42-108t42-108q42-42 108-42t108 42q42 42 42 108t-42 108q-42 42-108 42t-108-42Zm167 304Zm5.5-347.5Q490-593 490-632t-25.5-64.5Q439-722 400-722t-64.5 25.5Q310-671 310-632t25.5 64.5Q361-542 400-542t64.5-25.5ZM400-632Z"
                fill={fill}
            />
        </SvgIcon>
    );
};

AskHRExpertIcon.propTypes = {
    fill: string,
    height: string,
    onClick: func,
    viewBox: string,
    width: string,
};

AskHRExpertIcon.defaultProps = {
    fill: '#282828',
    height: '20',
    onClick: () => {},
    viewBox: '0 -960 960 960',
    width: '20',
};

export default AskHRExpertIcon;
